// Angular
import { Component, OnInit } from '@angular/core';
// Layout
import { LayoutConfigService } from '../../../core/_base/layout';
// Object-Path
import * as objectPath from 'object-path';
import { AppService } from '../../../services/app.service';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments';

@Component({
	selector: 'kt-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss'],

})
export class FooterComponent implements OnInit {
	// Public properties
	today: number = Date.now();
	fluid: boolean;
	version: Observable<string>;
	footerLogo: string;
	backgroundPage: string;

	/**
	 * Component constructor
	 *
	 * @param layoutConfigService: LayouConfigService
	 */
	constructor(
		private layoutConfigService: LayoutConfigService,
		private _appService: AppService
		) {
		this.footerLogo = environment.assets.footerLogo;
		this.backgroundPage = environment.assets.footerBackground;
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		const config = this.layoutConfigService.getConfig();

		// footer width fluid
		this.fluid = objectPath.get(config, 'footer.self.width') === 'fluid';

		this.version = this._appService.getAppVersion();
	}

	getPageBackground() {
		return `url(${this.backgroundPage})`;
	}
}
